/*______________for github related stuffs___________*/
export const CLEAR_USERS = 'CLEAR_USERS';
export const GET_REPOS = 'GET_REPOS';
export const GET_USERINFO= 'GET_USERINFO';
export const SEARCH_USERS = 'SEARCH_USERS';
export const SET_LOADING = 'SET_LOADING';

/*______________for alert________________*/
export const REMOVE_ALERT= 'REMOVE_ALERT';
export const SET_ALERT = 'SET_ALERT';



